import React from "react";
import { marginSize, paddingSize } from "../../../../Utilities/utils/Theming";
import { TView } from "../types";
import { StyleObject } from "src/Themes";

export const asideStyling = {
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    color: 'var(--epods--color-grey-950)',

    // TODO: this needs to be integrated with the header panels
    height: '100%',
}

export const shortcutsScrollableContainerStyle = {
    // overflowY: 'auto',
    flex: '1 1 auto',
    ...paddingSize('var(--epods--space-inset-m)', 'var(--epods--space-inset-m)', 'var(--epods--space-inset-m)', 'var(--epods--space-inset-m)'),
};

export const unstyledListStyle = {
    listStyleType: 'none',
    ...marginSize('0', '0', '0', '0'),
    ...paddingSize('0', '0', '0', '0'),
};

export const labelStyle = {
    color: 'var(--epods--color-text-primary)',
    maxWidth: '251px',
    marginRight: 'var(--epods--space-inset-s)',
    flexGrow: 1,
    lineClamp: 2,
    alignSelf: 'center'
}

export const itemStyle = {
    display: 'flex',
    justifyContent: 'space-between'
}

export const shortcutActionsStyle: StyleObject = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...paddingSize('var(--epods--space-inset-m)', 'var(--epods--space-inset-m)', '2px', 'var(--epods--space-inset-m)'),
    position: 'relative',
}